
 <!-- <div class="content-wrapper pt-2"> -->
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Generator Usage</div> 
      <form  [formGroup] ="form"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="row">

        <div class="form-group">
          <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="startDate" class="col-form-label ">Start Date</label>  
              <div class="input-group">
                  <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="startDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.startDate" (blur)="logValidationErrors()" placeholder="Start Date">
              </div>
              <span class="text-danger" *ngIf="formErrors.startDate"><small>{{formErrors.startDate}}</small> </span>   
              </div>
           </div>

                 
        <div class="col-md-4">        
            <div class="form-group">
            <label for="startReading" class="col-form-label ">Start Reading</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="startReading" placeholder="Start Reading"  class="form-control field-bg-color"  [class.is-invalid]="formErrors.startReading" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.startReading"><small>{{formErrors.startReading}}</small> </span>   
           </div>      
        </div>

        </div>
  

    <div class="row">  
  
        <div class="col-md-4">
            <div class="form-group">
            <label for="endDate" class="col-form-label ">End Date</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="endDate" class="form-control field-bg-color" [class.is-invalid]="formErrors.endDate" (blur)="logValidationErrors()" placeholder="End Date">
            </div>
            <span class="text-danger" *ngIf="formErrors.endDate"><small>{{formErrors.endDate}}</small> </span>   
            </div>
        </div>
        
        <div class="col-md-4">
            <div class="form-group">
            <label for="endReading" class="col-form-label ">End Reading</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input (keyup)="calculateAmounts()"  [ngClass]="{'dark-input-field' : isDark }" formControlName="endReading" placeholder="End Reading" class="form-control"[class.is-invalid]="formErrors.endReading" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.endReading"><small>{{formErrors.endReading}}</small> </span>   
           </div>
        </div>

    </div>

        <div class="row">  

            <div class="col-md-4">        
                <div class="form-group">
               <label for="consumption" class="col-form-label ">Consumption</label>  
               <div class="input-group">
                 <div class="input-group-prepend">
               <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
               </div>
               <input  readonly [ngClass]="{'dark-input-field' : isDark }" formControlName="consumption" placeholder="Consumption"  class="form-control field-bg-color"  [class.is-invalid]="formErrors.consumption" (blur)="logValidationErrors()" type="text">
             </div>
             <span class="text-danger" *ngIf="formErrors.consumption"><small>{{formErrors.consumption}}</small> </span>   
              </div>
              </div>

        <div class="col-md-4">        
            <div class="form-group">
           <label for="fuel" class="col-form-label ">Fuel (Liters)</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="fuel" placeholder="Fuel (Liters)"  class="form-control"   type="text">
         </div>
          </div>
          </div>

        </div>

      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button *ngIf="crud_access.create"  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-primary ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../generator-usage-list"><i class="fa fa-table p-1"></i>Generator Usage List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
    <!-- </div> -->


    <!-- Form Values : {{ addCustomerForm.value | json }} -->
  
